import {pageInfo, exportData, geQcResultReImport} from '../api';
import {Message} from 'element-ui';
import { plant } from '../../../../../api'

const qcSampling = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj:[],
    exportObj: [],
    qcResultReImportObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({...item, btns: [item.showReuploadOptFlag == 'Y' ? true : false]}));
    },
    PLANT(state, data) {
      state.plantObj = (data.obj || []).map(item => ({ key: item.plantName, value: item.plantCode }))
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    QC_RESULT_RE_IMPORT_DATA(state, data) {
      state.qcResultReImportObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async geQcResultReImport({commit}, obj) {
      let resp = await geQcResultReImport(obj);
      commit('QC_RESULT_RE_IMPORT_DATA', resp);
    },
  }
}
export default qcSampling



// WEBPACK FOOTER //
// ./src/page/bd/qc/qcSampling/store/qcSampling.store.js